export default __webpack_public_path__ + "static/media/card1.aca0c4d8.wav";